<template>
  <div class="row head">
    <div class="col first-col">
      {{ $t('pages.documents.name') }}
    </div>
    <div class="col second-col">
      {{ $t('pages.documents.type') }}
    </div>
    <div class="col third-col">
      {{ $t('pages.documents.size') }}
    </div>
  </div>
  <LoadingIndicator v-if="isFetching" />
  <client-only
    v-else
    fallback-tag="div"
    class="documents-table"
  >
    <div
      v-for="item in content"
      :key="item.id"
      class="row"
      data-cy="document-item"
    >
      <div
        :style="{ backgroundImage: getIcon(item) }"
        class="col first-col img"
      >
        <span class="mobile-table">{{ $t('pages.documents.name') }}:</span>
        <nuxt-link
          v-if="item.isFolder"
          :to="item.url"
          data-cy="folder-link"
        >
          {{ item.folder_name }}
        </nuxt-link>
        <a
          v-else
          :href="item.url"
          target="_blank"
          rel="noopener noreferrer"
          data-cy="document-link"
          >{{ item.file_name }}
        </a>
      </div>
      <div class="col second-col">
        <span class="mobile-table">{{ $t('pages.documents.type') }}:</span>
        <span>{{ item.file_extension || '-' }}</span>
      </div>
      <div class="col third-col">
        <span class="mobile-table">{{ $t('pages.documents.size') }}:</span>
        <span>{{ item.file_size || '-' }}</span>
      </div>
    </div>
  </client-only>
</template>

<script setup>
import { toRefs } from 'vue';
import { getIcon } from '../helpers/document-icons';
import LoadingIndicator from './global/LoadingIndicator.vue';

const props = defineProps({
  content: {
    type: Array,
    default: () => [],
  },
  isFetching: {
    type: Boolean,
    default: false,
  },
});

const { content, isFetching } = toRefs(props);
</script>

<style scoped lang="scss">
.row {
  overflow: auto;
  border-bottom: 1px solid #f0f0f0;
  @media screen and (max-width: 1000px) {
    margin-top: 10px;
    padding-bottom: 10px;
  }
  &.head {
    padding: 5px;
    color: #000;
    font-size: 14px;
    padding-left: 10px;
    @media screen and (max-width: 1000px) {
      display: none;
    }
    .col {
      padding-bottom: 0;
    }
  }
  .col {
    color: #4c4c4c;
    line-height: 24px;
    padding-top: 15px;
    padding-bottom: 15px;
    box-sizing: border-box;
    float: left;
    line-height: 24px;
    a {
      word-wrap: break-word;
      hyphens: auto;
      text-decoration: none;
      color: #4c4c4c;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  .first-col {
    width: 60%;
    &.img {
      @media screen and (max-width: 1000px) {
        padding-left: 70px;
      }
      padding-left: 90px;
      background-repeat: no-repeat;
      background-position: left 4px center;
      background-size: 48px auto;
    }
  }
  .second-col {
    width: 10%;
  }
  .third-col {
    width: 30%;
  }
  .first-col,
  .second-col,
  .third-col {
    @media screen and (max-width: 1000px) {
      padding-top: 3px;
      padding-bottom: 3px;
      width: 100%;
      padding-left: 70px;
    }
  }
  .mobile-table {
    display: none;
    font-weight: bold;
    width: 3.5em;
    @media screen and (max-width: 1000px) {
      display: inline-block;
    }
  }
}
</style>
